import { memo, useRef, useEffect } from 'react';

import { SPALink } from '@hh.ru/redux-spa-middleware';
import Column from 'bloko/blocks/column';
import BlokoLink from 'bloko/blocks/link';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';
import { NON_BREAKING_SPACE } from 'src/utils/constants/symbols';
import { sendRealBannerViewAnalytics } from 'src/utils/sendAdvSpyAnalytics';

interface AnnouncementBannerProps {
    hideOnXs?: boolean;
}

const TrlKeys = {
    advMark: 'banners.advMark',
};

const AnnouncementBanner: TranslatedComponent<AnnouncementBannerProps> = ({ hideOnXs, trls }) => {
    const banner = useSelector(({ managerAnnouncementBanner }) => managerAnnouncementBanner);
    const wrapperRef = useRef(null);

    useEffect(() => {
        if (banner?.viewUrl && wrapperRef.current) {
            sendRealBannerViewAnalytics({ element: wrapperRef.current, viewUrl: banner.viewUrl });
        }
    }, [banner]);

    if (!banner) {
        return null;
    }

    const { click, body, isExternalAdvertising, advertiserLegalName } = banner;

    return (
        <Column xs={hideOnXs ? '0' : '4'} s="8" m="12" l="16">
            <div className="announcement" ref={wrapperRef}>
                <BlokoLink Element={SPALink} to={click} disableVisited>
                    {body}
                </BlokoLink>
                {isExternalAdvertising && (
                    <div className="announcement__adv-mark">
                        <div className="announcement__adv-limit">
                            {`${trls[TrlKeys.advMark]}${NON_BREAKING_SPACE}∙${NON_BREAKING_SPACE}18+`}
                        </div>
                        <div>{advertiserLegalName}</div>
                    </div>
                )}
            </div>
        </Column>
    );
};

export default memo(translation(AnnouncementBanner));
